import { isNumber } from './../utils';
/**
 * Compares numeric options and updates element options if they have changed.
 * @param options - The new options to compare against
 * @param fields - Array of field names to check for changes
 * @returns True if any numeric options have changed, false otherwise
 */
export function diffNumericOptions(options, fields) {
    const elementOptions = this.options;
    let hasChanges = false;
    let value, field;
    for (let i = 0; i < fields.length; i++) {
        field = fields[i];
        value = options[field];
        if (isNumber(value) && elementOptions[field] !== value) {
            elementOptions[field] = value;
            hasChanges = true;
        }
    }
    return hasChanges;
}
